import Icon from 'components/shared/Icon/Icon';

import AcceptCheckbox from './AcceptCheckbox';
import BulletItem from './BulletItem';
import Divider from './Divider';
import TermsCard from './TermsCard';

const MyriadHealthTermsSection = ({
  isAdmin,
  isCompleted,
  myriadHealthAccepted,
  setMyriadHealthAccepted
}) => {
  return (
    <TermsCard
      title="Myriad Health"
      subtitle="Software access, compliance, and onboarding standards:">
      <ul className="flex flex-col gap-2">
        <BulletItem>
          <span className="font-600">HIPAA + security.</span> EHR use must comply with HIPAA,
          applicable privacy and security laws, and Myriad cybersecurity standards. You are
          responsible for user, device, and access compliance.
        </BulletItem>
        <BulletItem>
          <span className="font-600">Data exports.</span> You are responsible for obtaining usable
          export files from prior systems. Myriad is not responsible for third-party export costs,
          delays, refusals, or restrictive formats.
        </BulletItem>
        <BulletItem>
          <span className="font-600">Myriad Motion onboarding.</span> Timely completion of
          onboarding tasks through Myriad Motion is required to meet go-live expectations.
        </BulletItem>
        <BulletItem>
          <span className="font-600">Governing terms.</span> Use of Myriad Health is subject to the
          Software Order Terms and Business Associate Agreement (BAA).
        </BulletItem>
        <li className="flex flex-col gap-2 pl-4">
          <a
            href="https://myriadsystems.ai/myriad-health-software-terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm font-400 italic text-primary-600 !underline hover:text-neutral-500">
            <Icon icon="uncolored-dot-indicators" size={12} /> Review BAA & Order Terms
          </a>
        </li>
      </ul>
      <Divider />
      <AcceptCheckbox
        id="myriad-health-accept"
        label="I have read, understand, and agree to the Myriad Health terms in full."
        isChecked={isCompleted || myriadHealthAccepted}
        onChange={() => setMyriadHealthAccepted(!myriadHealthAccepted)}
        disabled={isCompleted || isAdmin}
        tooltip={
          isAdmin && !isCompleted
            ? 'This step must be completed by a user. Admins cannot acknowledge it.'
            : null
        }
      />
    </TermsCard>
  );
};

export default MyriadHealthTermsSection;
